<template>
    <div class="relative">
        <Link :href="'/fruit/'+fruit.slug">
        <div class="absolute flex items-center mt-20">
            <img
            class="object-cover w-24 h-24 ml-4 bg-white border-2 rounded-full border-enriqueto_green"
            :src="fruit.image"
            :alt="fruit.name"
            width="96"
            height="96"
            loading="lazy"
            decoding="async"
            />
        </div>

        <div
            class="transition-all duration-700 shadow-md hover:shadow-xl bg-yellow rounded-3xl hover:bg-opacity-70"
        >
            <div class="h-36 graph-correction">
                <vue3-chart-js
                    :id="lineGraphChart.id"
                    :type="lineGraphChart.type"
                    :data="lineGraphChart.data"
                    :options="lineGraphChart.options"
                    @before-render="beforeRenderLogic"
                ></vue3-chart-js>
            </div>

            <div
            class="flex flex-col items-center justify-around w-full min-h-1/2 bg-opacity-30 rounded-b-3xl"
            :class="fruit.increase === null ? 'bg-light_gray' : (fruit.increase >= 0 ? 'bg-enriqueto_green' : 'bg-red')"
            >
            <div class="flex items-center justify-between w-full px-6 pt-10 pb-5 min-h-1/2 bg-light_yellow rounded-3xl" style="min-height: 150px;">

                <div class="flex flex-col w-full">
                    <h3 class="text-enriqueto_green">{{fruit.name}}</h3>
                    <p class="text-enriqueto_green">{{usePriceFormat(fruit.price)}} / {{fruit.unit}}</p>
                </div>
                <div class="flex items-center justify-center m-2">
                    <div class="flex flex-col items-center justify-center m-2">
                        <p class="text-enriqueto_green">24H</p>
                        <p class="font-bold" :class="movementClass(fruit.increase)">{{formatMovement(fruit.increase)}}</p>
                    </div>
                    <div class="flex flex-col items-center justify-center m-2">
                        <p class="text-enriqueto_green">7D</p>
                        <p class="font-bold" :class="movementClass(fruit.week_increase)">{{formatMovement(fruit.week_increase)}}</p>
                    </div>
                </div>
            </div>

            </div>
        </div>
        </Link>
    </div>
</template>

<script>
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'
import { Link } from '@inertiajs/inertia-vue3'
import usePriceFormat from '../../Services/usePriceFormat'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    components: {
        Vue3ChartJs,
        Link
    },
    props: ['fruit'],
    setup (props) {
    const formatMovement = value => value === null || value === undefined ? '—' : `${value}%`
    const movementClass = value => value === null || value === undefined
        ? 'text-gray'
        : (value >= 0 ? 'text-enriqueto_green' : 'text-red')
    let reports = props.fruit.last_reports;
    reports.forEach(item => {
        item.value = Number(item.value)+1;
        console.log(item);
    }); 
    let value_report = reports.map(({ value }) => value)
    let date_report = reports.map(({ created_at }) => created_at)
    if(reports.length<2){
        value_report = [
            Number(props.fruit.price)+1,
            Number(props.fruit.price)+1
        ]
        date_report = [
            Number(props.fruit.price)+1,
            Number(props.fruit.price)+1
        ]
    } 
    const store = useStore()
    const dark_mode = computed(() => store.state.dark_mode)
    let greenColor = 'rgba(3, 102, 46,0.3)'
    let redColor = 'rgba(255,0,0,0.5)'
    let borderColor = greenColor
    let color = greenColor
    if(dark_mode.value){
        greenColor = '#22D66F'
        redColor = 'rgba(255,0,0,0.5)'
        borderColor = greenColor
        color = greenColor
    }
    if(props.fruit.increase<0){
        borderColor = redColor
        color = redColor
    }
    

    const lineGraphChart = {
        id: 'lineGraph'+props.fruit.id,
        type: 'line',
        data: {
            labels: date_report,
            datasets: [{ 
                data: value_report,
                borderColor: borderColor,
                pointBackgroundColor: borderColor,
                pointRadius: 2.5,
                fill: true,
                backgroundColor: color,
                hoverBackgroundColor: 'rgba(33, 150, 83, 0.6)',
                borderWidth: 1
            }
            ]
        },
        options: {
            showTooltips: false,

            layout: {
                padding: false
            },
            elements: {
                line: {
                    tension: 0.6
                }
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip:{
                    enabled:false
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
            mode: 'index',
            intersect: false
            },
            scales: {
            x: {
                display: false,
            },
            y: {
                display: false,
            }
            }
        },
    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

        return {
        lineGraphChart,
        beforeRenderLogic,
        usePriceFormat,
        formatMovement,
        movementClass
        }
    },
}
</script>

<style>

</style>
